import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { TopicLeaf } from '../../model/TopicLeaf';
import { Router, ActivatedRoute } from '@angular/router';
import { CoursewareService } from '../../services/CoursewareService';
import { IndexModelWithOverview } from '../../model/VideoCourses/IndexModelWithOverview';
import { Breadcrumb } from 'src/model/Breadcrumb';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { globals } from '../shared/globals';
import { MetaService } from 'src/services/MetaService';
import { LoginComponent } from '../account/login.component';
import { BaseComponent } from '../base.component';
import { LazyImagesComponent } from '../shared/lazy-images-component';

@Component({
  selector: 'app-videocourses',
  templateUrl: './videocourses.component.html',
  styleUrls: ['./videocourses.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class VideocoursesComponent extends LazyImagesComponent implements OnInit, OnDestroy {
  public videoCourses: IndexModelWithOverview;
  public static cachevideoCourses: IndexModelWithOverview;
  public currentTopic: TopicLeaf = null;
  showTopics: boolean = true;
  showContentEntries: boolean = false;
  public breadcrumbs: Breadcrumb[] = [];
  showVideo: boolean = false;
  static userCachedFor = null;

  showTopic: boolean = true;
  showLatest: boolean = false;
  showBadges: boolean = false;
  playingVideo: boolean = false;
  loading: boolean = true;
  public currentLatestCount = 18;
  public topicArea: string = "/videocoursesview";
  public contentArea: string = "/videocoursescontentview";

  constructor(private canonicalService: MetaService, private titleService: Title, private route: ActivatedRoute, private _router: Router, private coursewareService: CoursewareService, private alertService: AlertService, private sanitizer: DomSanitizer) {
    super();
    this.getVideoCourses();
    this.titleService.setTitle("Video-Courses - Lawshelf Educational Media");
  }
  /*
    getImages() {
      if (!this.videoCourses || !this.videoCourses.indexModel || !this.videoCourses.indexModel.EarnedBadgess)
        return 0;
      return this.videoCourses.indexModel.EarnedBadgess.length;
    }
  */

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }

  showMoreLatest() {
    this.currentLatestCount += 18;
    this.loadedImages = false;
    this.totalImages = 3;
  }

  hasMoreLatest() {
    if (this.videoCourses && this.currentLatestCount < this.videoCourses.indexModel.AllDigitalBadges.length) {
      return true;
    }
    return false;
  }

  hideVideo() {
    this.showVideo = false;
    this.playingVideo = false;
  }

  playTheVideo() {
    this.playingVideo = true;
  }

  displayTopicTab() {
    if (this.showTopic)
      return true;
    return false;
  }

  displayLatestTab() {
    if (this.showLatest)
      return true;
    return false;
  }

  displayEarnedTab() {
    if (this.showBadges)
      return true;
    return false;
  }

  getImageUrl(aEntry) {
    if (aEntry) {
      let justTheUrl = '/assets/databaseimages/' + aEntry.ThumbnailFilename;
      return this.sanitizer.bypassSecurityTrustStyle("url(" + justTheUrl + ")")
    }
    return "";
  }

  showTheTopicTab() {
    this.showTopic = true;
    this.showLatest = false;
    this.showBadges = false;
    this.setNumberOfImages();
    this.loadedImages = false;
  }

  showTheLatestTab() {
    this.showTopic = false;
    this.showLatest = true;
    this.showBadges = false;
    this.setNumberOfImages();
    this.loadedImages = false;
  }

  showTheBadgesTab() {
    this.showTopic = false;
    this.showLatest = false;
    this.showBadges = true;
    this.setNumberOfImages();
    this.loadedImages = false;
  }

  topicTabClass() {
    if (this.showTopic)
      return "active";
    return "";
  }

  latestClass() {
    if (this.showLatest)
      return "active";
    return "";
  }

  badgesClass() {
    if (this.showBadges)
      return "active";
    return "";
  }

  isLoading() {
    if (this.loading)
      return "inline-block";
    return "none";
  }


  getVideoCourses() {
    this.pushAllAds(2);
    if (!VideocoursesComponent.cachevideoCourses || (globals.userName != VideocoursesComponent.userCachedFor)) {
      this.loading = true;
      this.coursewareService.getVideocourses(globals.token).subscribe(data => {
        this.videoCourses = VideocoursesComponent.cachevideoCourses = data;
        this.loading = false;

        if (!this.videoCourses.indexModel) {
          this.videoCourses = VideocoursesComponent.cachevideoCourses = null;
          let error: Error = data;
          this.alertService.error(error.Message);
          return;
        }
        VideocoursesComponent.userCachedFor = globals.userName;
        this.initialize();
        return;
      });
      return;
    }
    this.loading = false;
    this.videoCourses = VideocoursesComponent.cachevideoCourses;
  }

  public getTopicLeaf(alias: string) {
    if (!this.videoCourses) {
      if (VideocoursesComponent.cachevideoCourses)
        this.videoCourses = VideocoursesComponent.cachevideoCourses;
      else {
        this.getVideoCourses();
        return;
      }
    }
    try {
      for (let video of this.videoCourses.indexModel.TopicLeaves) {
        if (alias == video.TopicInformation.Alias) {
          return video;
        }
      }
    } catch (ex) {
      console.log("getTopicLeaf " + alias);
    }
    return null;
  }

  ngOnInit() {
    this.initialize();
  }

  hasBadges() {
    if (this.videoCourses && this.videoCourses.indexModel && this.videoCourses.indexModel.EarnedBadgess && this.videoCourses.indexModel.EarnedBadgess.length > 0)
      return true;
    return false;
  }

  initialize() {
    let alias = this.route.snapshot.paramMap.get('alias');
    let fromBanner = this.route.snapshot.paramMap.get('frombanner');
    //   if (fromBanner)
    //     this.showVideo = true;
    if (!LoginComponent.user)
      this.showVideo = true;
    if (!alias) {
      this.currentTopic = null;
      this.showTopics = true;
      this.showContentEntries = false;
      this.breadcrumbs = [{ Title: "Video-Courses", URL: "/videocoursesview" }];
      //      if (fromBanner)
      //        this.canonicalService.createCanonicalURL(this._router.url,"/videocoursesbannerview/frombanner");
      //      else
      this.canonicalService.createCanonicalURL(this._router.url, "/videocoursesview/");
    } else {
      this.showTopics = false;
      this.showContentEntries = true;
      this.currentTopic = this.getTopicLeaf(alias);
      if (this.currentTopic) {
        this.breadcrumbs = [{ Title: "Video-Courses", URL: "/videocoursesview" }, { Title: this.currentTopic.TopicInformation.Title, URL: "/videocoursesview/" + alias }];
        this.canonicalService.createCanonicalURL(this._router.url, "/videocoursesview/" + alias);
      }
    }
    this.setNumberOfImages();
  }

  public setNumberOfImages() {
    if (this.displayTopicTab() && this.videoCourses) {
      if (!this.currentTopic) {
        this.totalImages = this.videoCourses.indexModel.TopicLeaves.length;
      } else {
        this.totalImages = this.currentTopic.contentEntries.length;
      }
    } else if (this.displayLatestTab() && this.videoCourses) {
      this.totalImages = 18; // we dont show this right away
      //      this.totalImages = this.videoCourses.indexModel.AllDigitalBadges.length;
    } else if (this.displayEarnedTab() && this.videoCourses) {
      this.totalImages = this.videoCourses.indexModel.EarnedBadgess.length;
    } else if (this.currentTopic && this.showContentEntries) {
      this.totalImages = this.currentTopic.contentEntries.length;
    }
  }
}